module.exports = __webpack_public_path__ + "static/working_for_google-473459a9f129df396f6127bc596da923.png";